import styles from './index.module.scss'
import { Table, message, Drawer, Input, Popover, Select, Upload, Segmented, Button, Divider } from 'antd'
import { useState, useCallback, useMemo, useEffect, useRef, useContext, forwardRef, useImperativeHandle } from "react"
import SelectTryonPose from '../components/SelectTryonPose'
import GoBack from "../components/GoBack";
import { useNavigate } from "react-router-dom";
import { EditOutlined, PlusOutlined, LoadingOutlined, MinusOutlined } from '@ant-design/icons';
import PSAIModal from '@PSAIComponents/PSAIModal';
import Iconfont from '@utils/Iconfont';
import ServiceSampleModal from '@view/compoents/ServiceSampleModal'
import Utils from '@utils/utils';
import UploadBox from '../components/UploadBox'
import API from "@api/api";
import { UPLOAD_SOURCE, BATCH_IMAGES_TYPE, BATCH_RECORD_TYPE } from "@utils/CONST"
import TableUploadView from './components/TableUploadView.jsx'
import { BatchImagesContext } from '../BatchImagesContext.js'
import InputNumber from './components/InputNumber.jsx'
import DragAndSort from './components/DragAndSort/DragAndSort.jsx'
import { SimRecolorInputCell, SimRecolorClothTypeCell, SimRecolorMatchCell } from './components/TableHooks/SimRecolorBatch'
import FusionWearBatch, { FusionWearPrompt } from './components/TableHooks/FusionWearBatch'
import { GrassPlantModelCell, GrassPlantBkgCell } from './components/TableHooks/GrassPlantBatch'
import { Image2VideoStartCell, Image2VideoEndCell, Image2VideoPromptCell } from './components/TableHooks/Image2VideoBatch'

const SelectionMask = ({ show }) => {
    if (!show) return null
    return <div style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', background: 'rgba(255, 255, 255, 0.6)', zIndex: 10, cursor: 'not-allowed' }} onClick={(e) => { e.stopPropagation(); e.preventDefault(); }} />
}

const isFusionLikeProjectType = (projectType) => {
    return [
        BATCH_IMAGES_TYPE.FUSIONWEAR_BATCH,
        BATCH_IMAGES_TYPE.SMART_DETAIL_PAGE_BATCH
    ].includes(projectType)
}

const TableWrap = forwardRef((props, ref) => {
    useImperativeHandle(ref, () => ({
        setUploadOpen,
        handleRemove,
        openReferenceDrawer,
        getBatchMode,
    }))
    const { setFileList, uploadImgToSkuId, setUploadImgToSkuId, isBatchAppendSmartPage, setIsBatchAppendSmartPage } = useContext(BatchImagesContext)
    const { projectType, dataSource, setDataSource, projectId, uploading, projectName, total, editSkuId, editTaskId, isEdit, isProCenter, projectSerial, selectedRowKeys, setSelectedRowKeys, selectedRows, setSelectedRows, showSelectionColumn, setShowSelectionColumn, footerBarRef } = props
    const navigate = useNavigate()
    const [drawOpen, setDrawOpen] = useState(false)
    const [pendingRefDropFiles, setPendingRefDropFiles] = useState(null)
    const [editNameVisible, setEditNameVisible] = useState(false)
    const [nickName, setNickName] = useState('')
    const [loading, setLoading] = useState(false)
    const [uploadOpen, setUploadOpen] = useState(false)
    const [commoditySortOpen, setCommoditySortOpen] = useState(false)
    const materialRef = useRef()
    const [editNameTitle, setEditNameTitle] = useState('修改商品名')
    const [uploadType, setUploadType] = useState(BATCH_IMAGES_TYPE.TRYON_BATCH) // AI试衣存在选模特和姿势两种情况
    const [uploadCount, setUploadCount] = useState(10) // 选择资源数量
    const [drawSelectedValue, setDrawSelectedValue] = useState([]) // 已选的素材


    const imageToVideoPromptPopoverContent = (
        <div style={{ width: 400 }}>
            <p>基础提示词由 <span style={{ color: '#006EFF' }}>主体</span>+<span style={{ color: '#FF8D29' }}>运动</span>，<span style={{ color: '#34C759' }}>背景</span>+<span style={{ color: '#006EFF' }}>运动</span> ... 组成</p>
            <Divider style={{ margin: '8px 0' }} />
            <p>主体：画面中占据核心视觉焦点的人物、动物、商品等核心对象；</p>
            <p>背景：画面内除核心主体外，用于衬托主体的所有环境元素；</p>
            <p>运动：核心主体与背景需达成的预设运动轨迹及动态呈现效果。</p>
            <p>精简和准确的描述“主体+运动”模型会更容易理解指令</p>
            <p>比如：<span style={{ color: '#006EFF' }}>画面中的女性</span><span style={{ color: '#FF8D29' }}>摘下墨镜</span>，<span style={{ color: '#34C759' }}>街上</span><span style={{ color: '#FF8D29' }}>行人经过</span></p>
        </div>
    )

    const skuColumns = useMemo(() => {
        let columns = [{
            title: '商品名称',
            key: '1',
            width: 250,
            render: (text, record) => {
                return <div className={styles.tableCellName}>
                    <p>ID:{record.skuSerial}</p>
                    <p>{record.skuName} {(!isEdit && !showSelectionColumn) &&
                        <EditOutlined style={{ color: '#96A2B1' }} onClick={() => editSkuName(record)} />} </p>
                </div>
            }
        }, {
            title: (
                <div style={{ display: "flex", gap: 8 }}>
                    <span>
                        <span style={{ color: '#FF0000' }}>*</span>
                        {projectType === BATCH_IMAGES_TYPE.TRYON_BATCH ? '商品图' :
                            projectType === BATCH_IMAGES_TYPE.IMAGE_FINER_BATCH ? '输入图' :
                                projectType === BATCH_IMAGES_TYPE.WATERMARK_REMOVE_BATCH ? '源素材' :
                                    projectType === BATCH_IMAGES_TYPE.GRASS_PLANT_BATCH ? '衣服图/模特穿搭图' :
                                        '模特图'}
                    </span>
                    {
                        (projectType != BATCH_IMAGES_TYPE.WATERMARK_REMOVE_BATCH &&
                            projectType != BATCH_IMAGES_TYPE.GRASS_PLANT_BATCH) && <Popover
                                placement="bottomLeft"
                                arrow={false}
                                content={<ServiceSampleModal showValue={projectType} />}
                            >
                            <Iconfont type="icon-QuestionCircleOutlined" className={styles.Icon} />
                        </Popover>
                    }
                </div>
            ),
            key: 'mianInput',
            width: projectType === BATCH_IMAGES_TYPE.IMAGE_FINER_BATCH || projectType === BATCH_IMAGES_TYPE.WATERMARK_REMOVE_BATCH ? 900 : 200,
            render: (text, record) => {
                return record?.inputImages?.filter(item => item.mainImage === true)?.length == 1 ?
                    <TableUploadView
                        isEdit={isEdit}
                        showSelectionColumn={showSelectionColumn}
                        projectType={projectType}
                        dataSource={dataSource}
                        setDataSource={setDataSource}
                        url={record?.inputImages?.filter(item => item.mainImage === true)[0]?.url}
                        item={record} type={BATCH_RECORD_TYPE.MAINIMG}
                        width={(projectType === BATCH_IMAGES_TYPE.TRYON_BATCH || projectType === BATCH_IMAGES_TYPE.WATERMARK_REMOVE_BATCH) ? 128 : 96}
                        listSkuByProject={props.listSkuByProject}
                        projectId={projectId}
                        onReupload={(file, fileList, item, type) => beforeUpload(file, fileList, item, type)} /> :
                    <div className={styles.coordinationWrap}>
                        <Upload.Dragger
                            accept='image/jpeg,image/png,image/webp,image/avif'
                            listType="picture-card"
                            showUploadList={false}
                            className={styles.MatchClothesUpload}
                            beforeUpload={(file, fileList) => beforeUpload(file, fileList, record, BATCH_RECORD_TYPE.MAINIMG)}
                            onDrop={(e) => handleDrop(e, BATCH_RECORD_TYPE.MAINIMG)}
                            disabled={loading}
                            multiple={false}
                        >
                            <div className={styles.SelectModelBtnContent}>
                                {loading ? <LoadingOutlined /> : <PlusOutlined />}
                                <p>上传{projectType === BATCH_IMAGES_TYPE.TRYON_BATCH ? '商品图' : '模特图'}</p>
                            </div>
                        </Upload.Dragger>
                    </div>
            }
        }]
        if (projectType === BATCH_IMAGES_TYPE.TRYON_BATCH) {
            columns.push(...[{
                title: (<><span style={{ color: '#FF0000' }}>*</span>服装类型</>),
                key: '3',
                width: 200,
                render: (text, record) => {
                    const clothType = record?.inputImages?.filter(item => item.mainImage === true)[0]?.clothType
                    return (
                        <div style={{ position: 'relative', display: 'inline-block' }}>
                            <SelectionMask show={showSelectionColumn} />
                            {clothType === '' ? <Select
                                suffixIcon={<LoadingOutlined />}
                                style={{ width: 140 }}
                                placeholder='自动识别服装类型'
                                disabled={true}
                            /> : <Select
                                style={{ width: 120 }}
                                disabled={isEdit}
                                onChange={(value) => clothTypeChange(record, value)}
                                placeholder="服装类型"
                                value={clothType}
                                options={[
                                    { value: 0, label: '上装' },
                                    { value: 1, label: '下装' },
                                    { value: 3, label: '连体装' }
                                ]}
                            />}
                        </div>
                    )
                }
            }, {
                title: '搭配（非必填）',
                key: '4',
                width: 200,
                render: (text, record) => {
                    const clothType = record?.inputImages?.filter(item => item.mainImage === true)[0]?.clothType
                    return (
                        record?.inputImages?.filter(item => item.mainImage === false)?.length == 1 ?
                            <div style={{ position: 'relative', display: 'inline-block' }}>
                                <SelectionMask show={showSelectionColumn} />
                                <TableUploadView
                                    url={record?.inputImages?.filter(item => item.mainImage === false)[0]?.url}
                                    item={record}
                                    type={BATCH_RECORD_TYPE.MATCHIMG}
                                    width={128}
                                    dataSource={dataSource}
                                    setDataSource={setDataSource}
                                    listSkuByProject={props.listSkuByProject}
                                    projectId={projectId}
                                    onReupload={(file, fileList, item, type) => beforeUpload(file, fileList, item, type)} />
                            </div> :
                            <div className={styles.coordinationWrap} style={{ position: 'relative' }}>
                                <SelectionMask show={showSelectionColumn} />
                                <Upload.Dragger
                                    accept='image/jpeg,image/png,image/webp,image/avif'
                                    listType="picture-card"
                                    showUploadList={false}
                                    className={styles.MatchClothesUpload}
                                    beforeUpload={(file, fileList) => beforeUpload(file, fileList, record, BATCH_RECORD_TYPE.MATCHIMG)}
                                    onDrop={(e) => handleDrop(e, BATCH_RECORD_TYPE.MATCHIMG)}
                                    disabled={(record?.matchLoading && uploading) || clothType === 3}
                                    multiple={false}
                                >
                                    <div className={styles.SelectModelBtnContent}>
                                        {record?.matchLoading ? <LoadingOutlined /> : <PlusOutlined />}
                                        <p>上传搭配图</p>
                                    </div>
                                </Upload.Dragger>
                            </div>
                    )
                }
            }, {
                title: '模特（非必填）',
                key: '5',
                width: 200,
                render: (text, record) => {
                    return (
                        record?.modelList?.length == 0 ?
                            <div className={styles.SelectModelBtn}
                                onClick={() => openReferenceDrawer([], 1, record, BATCH_IMAGES_TYPE.CHANGE_MODEL_BATCH)}>
                                <SelectionMask show={showSelectionColumn} />
                                <div className={styles.SelectModelBtnContent}>
                                    <PlusOutlined />
                                    <p>选择模特</p>
                                </div>
                            </div> : <div className={`${styles.ImageCell}`} >
                                <img src={Utils.getImgThumbnail(record?.modelList?.[0]?.url)} alt="" />
                                <SelectionMask show={showSelectionColumn} />
                                <div className={styles.maskBox}
                                    onClick={() => openReferenceDrawer([...record?.modelList], 1, record, BATCH_IMAGES_TYPE.CHANGE_MODEL_BATCH)}>
                                    <p><Iconfont type="icon-rebuildOutlined" /><span>重选</span></p>
                                </div>
                            </div>
                    )
                }
            }, {
                title: (<><span style={{ color: '#FF0000' }}>*</span>{'试衣参考图（1 - 10张）'}</>),
                key: '6',
                render: (text, record) => {
                    return (
                        record?.refList?.length == 0 ? <div
                            className={`${styles.SelectModelBtn} ${record?.error ? styles.SelectModelBtnError : ''}`}
                            style={{ width: 512 }}
                            onDragOver={(e) => e.preventDefault()}
                            onDrop={(e) => handleRefListDrop(e, record)}
                            onClick={() => openReferenceDrawer([], 10, record, BATCH_IMAGES_TYPE.TRYON_BATCH)}>
                            <SelectionMask show={showSelectionColumn} />
                            <div className={styles.SelectModelBtnContent}>
                                <PlusOutlined />
                                <p>选择1到10张试衣参考图</p>
                            </div>
                        </div> : <div className={styles.refListBox} style={{ maxWidth: 512 }}>
                            <SelectionMask show={showSelectionColumn} />
                            {record?.refList?.slice(0, 5).map((item, index) => (
                                <img key={index} src={Utils.getImgThumbnail(item.url)} alt="" />
                            ))}
                            {
                                record?.refList?.length > 5 && <p className={styles.number}><Iconfont type="icon-copyOutlined" /><span>{record?.refList?.length}</span></p>
                            }
                            <div className={styles.maskBox}
                                onClick={() => openReferenceDrawer([...record?.refList], 10, record, BATCH_IMAGES_TYPE.TRYON_BATCH)}>
                                <p><Iconfont type="icon-pencil" /><span>编辑</span></p>
                            </div>
                        </div>
                    )
                }
            }])
        } else if (projectType === BATCH_IMAGES_TYPE.CHANGE_MODEL_BATCH) {
            columns.push(...[{
                title: (<><span style={{ color: '#FF0000' }}>*</span>{'模特参考图（1 - 10张）'}</>),
                key: '9',
                render: (text, record) => {
                    return (
                        record?.modelList?.length == 0 ? <div
                            className={`${styles.SelectModelBtn} ${record?.error ? styles.SelectModelBtnError : ''}`}
                            style={{ width: 1032 }}
                            onClick={() => openReferenceDrawer([], 10, record, BATCH_IMAGES_TYPE.CHANGE_MODEL_BATCH)}>
                            <SelectionMask show={showSelectionColumn} />
                            <div className={styles.SelectModelBtnContent}>
                                <PlusOutlined />
                                <p>选择1到10张模特参考图</p>
                            </div>
                        </div> : <div className={styles.refListBox} style={{ maxWidth: 1032 }}>
                            <SelectionMask show={showSelectionColumn} />
                            {record?.modelList?.map((item, index) => (
                                <img key={index} src={Utils.getImgThumbnail(item.url)} alt="" />
                            ))}
                            {
                                record?.modelList?.length > 5 && <p className={styles.number}><Iconfont type="icon-copyOutlined" /><span>{record?.modelList?.length}</span></p>
                            }
                            <div className={styles.maskBox}
                                onClick={() => openReferenceDrawer([...record?.modelList], 10, record, BATCH_IMAGES_TYPE.CHANGE_MODEL_BATCH)}>
                                <p><Iconfont type="icon-pencil" /><span>编辑</span></p>
                            </div>
                        </div>
                    )
                }
            }])
        } else if (projectType === BATCH_IMAGES_TYPE.CHANGE_BKG_BATCH) {
            columns.push(...[{
                title: (<><span style={{ color: '#FF0000' }}>*</span>{'背景参考图（1 - 10张）'}</>),
                key: '10',
                render: (text, record) => {
                    return (
                        record?.bkgList?.length == 0 ? <div
                            className={`${styles.SelectModelBtn} ${record?.error ? styles.SelectModelBtnError : ''}`}
                            style={{ width: 824 }}
                            onDragOver={(e) => e.preventDefault()}
                            onDrop={(e) => handleRefListDrop(e, record)}
                            onClick={() => openReferenceDrawer([], 10, record, BATCH_IMAGES_TYPE.CHANGE_BKG_BATCH)}>
                            <SelectionMask show={showSelectionColumn} />
                            <div className={styles.SelectModelBtnContent}>
                                <PlusOutlined />
                                <p>选择1到10张背景参考图</p>
                            </div>
                        </div> : <div className={styles.refListBox} style={{ maxWidth: 824 }}>
                            <SelectionMask show={showSelectionColumn} />
                            {record?.bkgList?.map((item, index) => (
                                <img key={index} src={Utils.getImgThumbnail(item.url)} alt="" />
                            ))}
                            {
                                record?.bkgList?.length > 5 &&
                                <p className={styles.number}><Iconfont type="icon-copyOutlined" /><span>{record?.bkgList?.length}</span></p>
                            }
                            <div className={styles.maskBox}
                                onClick={() => openReferenceDrawer([...record?.bkgList], 10, record, BATCH_IMAGES_TYPE.CHANGE_BKG_BATCH)}>
                                <p><Iconfont type="icon-pencil" /><span>编辑</span></p>
                            </div>
                        </div>
                    )
                }
            }, {
                title: '场景相似度',
                key: 'customBkgMode',
                render: (text, record) => {
                    return (
                        <div style={{ position: 'relative', display: 'inline-block' }}>
                            <SelectionMask show={showSelectionColumn} />
                            <Segmented
                                value={record.customBkgMode}
                                disabled={showSelectionColumn}
                                options={[
                                    { label: '变化更多', value: 'free' },
                                    { label: '场景不变', value: 'sim' }
                                ]}
                                onChange={(value) => {
                                    setDataSource(prev =>
                                        prev.map(it => {
                                            if (it.skuId !== record.skuId) return it;
                                            return {
                                                ...it,
                                                customBkgMode: value,
                                            };
                                        })
                                    );
                                }}
                            />
                        </div>
                    )
                }
            }])
        } else if (projectType === BATCH_IMAGES_TYPE.SIM_RECOLOR_BATCH) {
            columns.push(...[{
                title: '平铺图类型',
                key: 'flatType',
                width: 200,
                render: (text, record) => {
                    return (
                        <div style={{ position: 'relative', display: 'inline-block' }}>
                            <SelectionMask show={showSelectionColumn} />
                            <Segmented
                                value={record.flatType || 'cloth'}
                                disabled={showSelectionColumn}
                                options={[
                                    { label: '衣服图', value: 'cloth' },
                                    { label: '面料图', value: 'material' }
                                ]}
                                onChange={(value) => {
                                    setDataSource(prev =>
                                        prev.map(it => {
                                            if (it.skuId !== record.skuId) return it;
                                            return {
                                                ...it,
                                                flatType: value,
                                            };
                                        })
                                    );
                                }}
                            />
                        </div>
                    )
                }
            }, {
                title: <p><span style={{ color: '#FF0000' }}>*</span>同款不同色平铺图</p>,
                key: BATCH_RECORD_TYPE.SIM_RECOLOR_INPUT,
                width: 200,
                render: (text, record) => {
                    return (
                        <div style={{ position: 'relative' }}>
                            <SelectionMask show={showSelectionColumn} />
                            <SimRecolorInputCell
                                record={record}
                                setDataSource={setDataSource}
                                listSkuByProject={props.listSkuByProject}
                                projectId={projectId}
                                uploading={uploading}
                                beforeUpload={beforeUpload}
                                handleDrop={handleDrop}
                            />
                        </div>
                    )
                }
            }, {
                title: (<><span style={{ color: '#FF0000' }}>*</span>需换色区域</>),
                key: '3',
                width: 200,
                render: (text, record) => {
                    return (
                        <div style={{ position: 'relative' }}>
                            <SelectionMask show={showSelectionColumn} />
                            <SimRecolorClothTypeCell
                                record={record}
                                showSelectionColumn={showSelectionColumn}
                                setDataSource={setDataSource}
                            />
                        </div>
                    )
                }
            }, {
                title: <p>搭配图（非必填）</p>,
                key: BATCH_RECORD_TYPE.SIM_RECOLOR_MATCH,
                width: 200,
                render: (text, record) => {
                    return (
                        <div style={{ position: 'relative' }}>
                            <SelectionMask show={showSelectionColumn} />
                            <SimRecolorMatchCell
                                record={record}
                                setDataSource={setDataSource}
                                listSkuByProject={props.listSkuByProject}
                                projectId={projectId}
                                hideUpload={record.flatType === 'material'}
                                uploading={uploading}
                                beforeUpload={beforeUpload}
                                handleDrop={handleDrop}
                            />
                        </div>
                    )
                }
            }])
        } else if (projectType === BATCH_IMAGES_TYPE.SMART_DETAIL_PAGE_BATCH) {
            columns = columns.filter(column => column.key !== 'mianInput')
            columns.push(...[{
                title: (<><span style={{ color: '#FF0000' }}>*</span>{'衣服图/模特图'}</>),
                key: 'smartDetailInput',
                render: (text, record) => {
                    return (
                        <div style={{ position: 'relative' }}>
                            <SelectionMask show={showSelectionColumn} />
                            <FusionWearBatch
                                record={record}
                                handleAddMore={props.handleAddMore}
                                projectId={projectId}
                                setDataSource={setDataSource}
                            />
                        </div>
                    )
                }
            }, {
                title: (<><span style={{ color: '#FF0000' }}>*</span>{'商品信息'}</>),
                key: 'smartDetailPrompt',
                width: 550,
                render: (text, record) => {
                    return (
                        <div style={{ position: 'relative' }}>
                            <SelectionMask show={showSelectionColumn} />
                            <FusionWearPrompt
                                record={record}
                                dataSource={dataSource}
                                setDataSource={setDataSource}
                            />
                        </div>
                    )
                }
            }, {
                title: '参考详情图',
                key: 'smartDetailRefer',
                width: 200,
                render: (text, record) => {
                    return (
                        record?.refList?.length == 0 ?
                            <div className={`${styles.SelectModelBtn} ${styles.SquareSelectBtn}`}
                                onClick={() => openReferenceDrawer([], 1, record, BATCH_IMAGES_TYPE.SMART_DETAIL_PAGE_BATCH)}>
                                <SelectionMask show={showSelectionColumn} />
                                <div className={styles.SelectModelBtnContent}>
                                    <PlusOutlined />
                                    <p>选择参考图</p>
                                </div>
                            </div> : <div className={`${styles.ImageCell} ${styles.SquareSelectBtn}`} >
                                <img src={Utils.getImgThumbnail(record?.refList?.[0]?.url)} alt="" />
                                <SelectionMask show={showSelectionColumn} />
                                <div className={styles.maskBox}
                                    onClick={() => openReferenceDrawer([...record?.refList], 1, record, BATCH_IMAGES_TYPE.SMART_DETAIL_PAGE_BATCH)}>
                                    <p><Iconfont type="icon-rebuildOutlined" /><span>重新选择</span></p>
                                </div>
                                <div className={styles.SmartDetailReferTitle}>按参考图结构生成</div>
                            </div>
                    )
                }
            }])
        } else if (isFusionLikeProjectType(projectType)) {
            columns = columns.filter(column => column.key !== 'mianInput')
            columns.push(...[{
                title: (<><span style={{ color: '#FF0000' }}>*</span>{'穿搭商品图'}</>),
                key: '5',
                render: (text, record) => {
                    return (
                        <div style={{ position: 'relative' }}>
                            <SelectionMask show={showSelectionColumn} />
                            <FusionWearBatch
                                record={record}
                                handleAddMore={props.handleAddMore}
                                projectId={projectId}
                                setDataSource={setDataSource}
                            />
                        </div>
                    )
                }
            }, {
                title: '模特（非必填）',
                key: '6',
                width: 200,
                render: (text, record) => {
                    return (
                        record?.modelList?.length == 0 ?
                            <div className={styles.SelectModelBtn}
                                onClick={() => openReferenceDrawer([], 1, record, BATCH_IMAGES_TYPE.FUSIONWEAR_BATCH)}>
                                <SelectionMask show={showSelectionColumn} />
                                <div className={styles.SelectModelBtnContent}>
                                    <PlusOutlined />
                                    <p>选择模特</p>
                                </div>
                            </div> : <div className={`${styles.ImageCell}`} >
                                <img src={Utils.getImgThumbnail(record?.modelList?.[0]?.url)} alt="" />
                                <SelectionMask show={showSelectionColumn} />
                                <div className={styles.maskBox}
                                    onClick={() => openReferenceDrawer([...record?.modelList], 1, record, BATCH_IMAGES_TYPE.FUSIONWEAR_BATCH)}>
                                    <p><Iconfont type="icon-rebuildOutlined" /><span>重选</span></p>
                                </div>
                            </div>
                    )
                }
            }, {
                title: '描述词（非必填）',
                key: '7',
                width: 550,
                render: (text, record) => {
                    return (
                        <div style={{ position: 'relative' }}>
                            <SelectionMask show={showSelectionColumn} />
                            <FusionWearPrompt
                                record={record}
                                dataSource={dataSource}
                                setDataSource={setDataSource}
                            />
                        </div>
                    )
                }
            },])
        } else if (projectType === BATCH_IMAGES_TYPE.GRASS_PLANT_BATCH) {
            columns.push(...[{
                title: (<>网红（非必选）</>),
                key: '9',
                render: (text, record) => (
                    <GrassPlantModelCell
                        record={record}
                        showSelectionColumn={showSelectionColumn}
                        openReferenceDrawer={openReferenceDrawer}
                    />
                )
            }, {
                title: (<>背景氛围图（非必选）</>),
                key: '10',
                render: (text, record) => (
                    <GrassPlantBkgCell
                        record={record}
                        showSelectionColumn={showSelectionColumn}
                        openReferenceDrawer={openReferenceDrawer}
                        handleRefListDrop={handleRefListDrop}
                    />
                )
            }])
        } else if (projectType === BATCH_IMAGES_TYPE.IMAGE_TO_VIDEO_BATCH) {
            columns = columns.filter(column => column.key !== 'mianInput')
            columns.push(...[{
                title: (<><span style={{ color: '#FF0000' }}>*</span>首帧图</>),
                key: 'startFrame',
                width: 200,
                render: (text, record) => (
                    <Image2VideoStartCell
                        record={record}
                        showSelectionColumn={showSelectionColumn}
                        isEdit={isEdit}
                        dataSource={dataSource}
                        setDataSource={setDataSource}
                        projectId={projectId}
                        listSkuByProject={props.listSkuByProject}
                        beforeUpload={beforeUpload}
                        handleDrop={handleDrop}
                        loading={loading}
                    />
                )
            }, {
                title: '尾帧图（非必填）',
                key: 'endFrame',
                width: 200,
                render: (text, record) => (
                    <Image2VideoEndCell
                        record={record}
                        showSelectionColumn={showSelectionColumn}
                        isEdit={isEdit}
                        dataSource={dataSource}
                        setDataSource={setDataSource}
                        projectId={projectId}
                        listSkuByProject={props.listSkuByProject}
                        beforeUpload={beforeUpload}
                        handleDrop={handleDrop}
                        loading={loading}
                        uploading={uploading}
                        clearMatchLoading={(skuId) => setSkuMatchLoadingList(prev => prev.filter(id => id !== skuId))}
                    />
                )
            }, {
                title: (
                    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                        <span><span style={{ color: '#FF0000' }}>*</span>视频画面描述</span>
                        <Popover content={imageToVideoPromptPopoverContent} placement="right">
                            <Iconfont className={styles.Icon} type="icon-qa2" />
                        </Popover>
                    </div>
                ),
                key: 'prompt',
                width: 700,
                render: (text, record) => (
                    <Image2VideoPromptCell
                        record={record}
                        showSelectionColumn={showSelectionColumn}
                        setDataSource={setDataSource}
                        openReferenceDrawer={openReferenceDrawer}
                    />
                )
            }])
        }
        columns.push(...[{
            title: '操作',
            fixed: 'right',
            key: '8',
            width: 150,
            render: (text, record) => {
                return <>
                    {
                        !isEdit &&
                        <Button
                            className={`${styles.DeleteBtn} ${showSelectionColumn ? styles.DeleteBtnDisabled : ''}`}
                            style={{ width: 68, height: 32 }}
                            onClick={() => handleRemove([record.skuId])}
                        ><Iconfont type="icon-DeleteOutlined" /> 删除</Button>
                    }
                </>
            }
        }])


        return columns
    }, [projectType, showSelectionColumn, dataSource, props.handleAddMore])

    const handleRemove = (skuId) => {
        PSAIModal.confirm({
            title: '是否删除源素材',
            content: <span style={{ color: "#FF3B30" }}>删除后将清空所有有关设置,此操作不可撤销</span>,
            onOk() {
                API.batchRemoveSku({
                    skuIds: [...skuId]
                }).then(res => {
                    if (res?.code === 0) {
                        message.success('删除成功！')
                        props.listSkuByProject()
                        footerBarRef.current?.handleBatchExit()
                    }
                })
            }
        })
    }

    const handleCopySku = (skuId) => {
        API.batchCopySku({
            skuId
        }).then(res => {
            if (res?.code === 0) {
                props.listSkuByProject()
            } else {
                message.error(res?.message)
            }
        })
    }

    // 修改服装类型
    const clothTypeChange = async (record, value) => {
        let updatedInputImages;
        if (value === 3) {
            // 当value === 3时，修改主图的clothType，并删除搭配图项
            updatedInputImages = record.inputImages
                .filter(item => item.mainImage)
                .map(item => ({ ...item, clothType: value }));
        } else {
            // 其他情况下，只修改主图的clothType
            updatedInputImages = record.inputImages.map(item =>
                item.mainImage ? { ...item, clothType: value } : item
            );
        }

        const saveRes = await API.batchSaveSku([{
            ...record,
            inputImages: updatedInputImages,
            projectId
        }])
        if (saveRes?.code === 0) props.listSkuByProject()
    }
    // 修改商品名/项目名
    const recordRef = useRef({})
    const editSkuName = (record) => {
        setEditNameTitle(`修改商品名`)
        setNickName(record.skuName)
        recordRef.current = record
        setEditNameVisible(true)
    }
    const editProjectName = () => {
        setEditNameTitle(`修改项目名`)
        setNickName(projectName)
        setEditNameVisible(true)
    }
    const updateNameOk = async () => {
        if (!nickName.trim()) { message.warning('请输入新名称'); return; }
        let saveRes = {}
        if (editNameTitle == '修改商品名') {
            saveRes = await API.batchSaveSku([{
                ...recordRef.current,
                skuName: nickName.trim(),
                projectId
            }])
        } else {
            saveRes = await API.batchUpdateProject({
                projectName: nickName,
                projectId
            })
        }
        if (saveRes?.code === 0) {
            setEditNameVisible(false)
            setNickName('')
            recordRef.current = {}
            props.listSkuByProject()
        }
    }

    function removeExtension(filename) {
        // 处理特殊文件名：'.' 和 '..'
        if (filename === '.' || filename === '..') return filename;
        const lastDot = filename.lastIndexOf('.');
        // 无后缀或隐藏文件（如 ".gitignore"）
        if (lastDot === -1 || lastDot === 0) return filename;
        return filename.substring(0, lastDot);
    }
    const uploadDebounce = useCallback(_.debounce(async (file, fileList, type, maxCount = 1, uploadRecord = null) => {
        setLoading(true)
        const uploadRecordSnapshot = uploadRecord || recordRef.current
        const uploadSkuId = uploadRecordSnapshot?.skuId
        const _fileList = maxCount == -1 ? fileList : fileList.slice(0, maxCount)
        for (let file of _fileList) {
            // 检查文件类型和宽高比
            let isNromal
            if (projectType === BATCH_IMAGES_TYPE.IMAGE_TO_VIDEO_BATCH) {
                isNromal = await Utils.validateImageFileToVideo(file)
            } else isNromal = await Utils.validateImageFile(file)
            if (!isNromal) { props.listSkuByProject(); clearSkuLoading(uploadSkuId); continue }

            // resize图片
            const resizeRes = await Utils.resizeImageFileMaxByAliyunBy(file, 4096)
            if (!resizeRes || !resizeRes.success) { message.warning(resizeRes?.message); props.listSkuByProject(); clearSkuLoading(uploadSkuId); continue; }
            file = resizeRes.file


            // 上传图片
            const legalRes = await Utils.checkImageIslegal(file, 0, UPLOAD_SOURCE.SERVICE)
            if (!legalRes || !legalRes.isLegal) { props.listSkuByProject(); clearSkuLoading(uploadSkuId); continue }
            const clothTextList = ['上装', '下装', null, '裙装']

            if (type == BATCH_RECORD_TYPE.MATCHIMG) {
                const isImageToVideoMatch = recordRef.current?.projectType === BATCH_IMAGES_TYPE.IMAGE_TO_VIDEO_BATCH || projectType === BATCH_IMAGES_TYPE.IMAGE_TO_VIDEO_BATCH
                if (isImageToVideoMatch) {
                    saveUploadImg(type, legalRes)
                } else {
                    const clothType = await API.getClothType({ imageUrl: legalRes?.data })
                    const mainImgClothType = recordRef.current?.inputImages?.filter(item => item.mainImage)?.[0]?.clothType
                    if ((clothType?.data === 0 && mainImgClothType === 1) || (clothType?.data === 1 && mainImgClothType === 0)) {
                        saveUploadImg(type, legalRes)
                    } else if (mainImgClothType === '') {
                        saveUploadImg(type, legalRes)
                    } else {
                        PSAIModal.confirm({
                            title: `上传的搭配图是否为${clothTextList[clothType.data]}？`,
                            content: `系统检测到您上传的图片可能是${clothTextList[mainImgClothType]}，若填入，可能会影响生成效果`,
                            okText: "继续填入",
                            cancelText: `取消上传`,
                            onOk() {
                                saveUploadImg(type, legalRes)
                            },
                            onCancel() {
                                setSkuMatchLoadingList(prev => prev.filter(id => id !== recordRef.current.skuId));
                            }
                        })
                    }
                }
            } else if (type == BATCH_RECORD_TYPE.SIM_RECOLOR_INPUT) {
                if (!uploadSkuId) continue
                setDataSource(prev =>
                    prev.map(item =>
                        item.skuId === uploadSkuId
                            ? {
                                ...item,
                                inputCloth: legalRes?.data,
                                clothType: uploadRecordSnapshot?.flatType === 'material'
                                    ? (item.clothType === '' || item.clothType === undefined || item.clothType === null ? 0 : item.clothType)
                                    : ''
                            } : item
                    )
                )
                clearSkuLoading(uploadSkuId)
            } else if (type == BATCH_RECORD_TYPE.SIM_RECOLOR_MATCH) {
                const saveRecolorMatch = () => {
                    setDataSource(prev =>
                        prev.map(item =>
                            item.skuId === recordRef.current.skuId
                                ? {
                                    ...item,
                                    matchCloth: legalRes?.data
                                } : item
                        )
                    );
                }
                const clothType = await API.getClothType({ imageUrl: legalRes?.data })
                if ((recordRef.current?.clothType === 0 && clothType?.data !== 1) ||
                    (recordRef.current?.clothType === 3) ||
                    (recordRef.current?.clothType === 1 && clothType?.data !== 0)) {
                    PSAIModal.confirm({
                        title: `上传的搭配图是否为${clothTextList[recordRef.current?.clothType]}？`,
                        content: `系统检测到您上传的图片可能是${clothTextList[clothType?.data]}，若填入，可能会影响生成效果`,
                        okText: "继续填入",
                        cancelText: `取消上传`,
                        onOk() { saveRecolorMatch() },
                        onCancel() { }
                    })
                } else {
                    saveRecolorMatch()

                }
            } else {
                const skuName = removeExtension(file.name)
                saveUploadImg(type, legalRes, skuName)
            }
        }
        setLoading(false)
    }, 100), [clearSkuLoading])

    // 修改堆叠主品图数量
    const handleNumberChange = (type, record, value) => {
        const currentNum = record.inputImages?.[0]?.num || 1;

        if (type === 'minus' && currentNum <= 1) return;
        if (type === 'add' && currentNum >= 50) return;

        let newNum;
        switch (type) {
            case 'minus':
                newNum = currentNum - 1;
                break;
            case 'add':
                newNum = currentNum + 1;
                break;
            case 'change':
                newNum = value;
                break;
            default:
                return;
        }

        setDataSource(prev =>
            prev.map(item =>
                item.skuId === record.skuId
                    ? {
                        ...item,
                        inputImages: item.inputImages?.map((img, index) =>
                            index === 0
                                ? { ...img, num: newNum }
                                : img
                        ) || [{ num: newNum }]
                    }
                    : item
            )
        );
    }

    const saveUploadImg = async (type, legalRes, skuName = null) => {
        const isImageToVideoMatch = (recordRef.current?.projectType === BATCH_IMAGES_TYPE.IMAGE_TO_VIDEO_BATCH || projectType === BATCH_IMAGES_TYPE.IMAGE_TO_VIDEO_BATCH) && type === BATCH_RECORD_TYPE.MATCHIMG
        if (isImageToVideoMatch) {
            const updatedRecord = skuName
                ? {
                    ...recordRef.current,
                    skuName,
                    imageTail: legalRes.data,
                    projectId
                }
                : {
                    ...recordRef.current,
                    imageTail: legalRes.data,
                    projectId
                };

            setDataSource(prev =>
                prev.map(item =>
                    item.skuId === recordRef.current.skuId
                        ? { ...item, ...updatedRecord }
                        : item
                )
            );
            setSkuMatchLoadingList(prev => prev.filter(id => id !== recordRef.current.skuId));
            recordRef.current = { ...updatedRecord };
            return
        }

        let updatedInputImages = [...recordRef.current.inputImages];
        const isMatchImg = type === BATCH_RECORD_TYPE.MATCHIMG;
        const targetMainImageValue = isMatchImg ? false : true;
        const existingIndex = updatedInputImages.findIndex(item => item.mainImage === targetMainImageValue);

        if (existingIndex !== -1) {
            updatedInputImages[existingIndex] = {
                mainImage: targetMainImageValue,
                url: legalRes.data
            };
        } else {
            updatedInputImages.push({
                mainImage: targetMainImageValue,
                url: legalRes.data
            });
        }

        const updatedRecord = skuName
            ? {
                ...recordRef.current,
                skuName,
                inputImages: updatedInputImages,
                projectId
            }
            : {
                ...recordRef.current,
                inputImages: updatedInputImages,
                projectId
            };

        // 更新 dataSource 中对应项
        setDataSource(prev =>
            prev.map(item =>
                item.skuId === recordRef.current.skuId
                    ? { ...item, ...updatedRecord }
                    : item
            )
        );
        recordRef.current = { ...updatedRecord };
    };


    // 为上传搭配图加上loading
    const [skuMatchLoadingList, setSkuMatchLoadingList] = useState([])
    const clearSkuLoading = useCallback((skuId) => {
        if (!skuId) return
        setSkuMatchLoadingList(prev => prev.filter(id => id !== skuId))
    }, [])
    useEffect(() => {
        if (!dataSource || dataSource.length === 0) return;

        let newData = dataSource.map(item => ({
            ...item,
            matchLoading: skuMatchLoadingList.includes(item.skuId),
        }));

        const finishedIds = newData
            .filter(item => projectType !== BATCH_IMAGES_TYPE.IMAGE_TO_VIDEO_BATCH && item.inputImages?.some(img => !img.mainImage))
            .map(item => item.skuId);

        if (finishedIds.length > 0) {
            setSkuMatchLoadingList(prev => prev.filter(id => !finishedIds.includes(id)));
        }

        const hasChange = newData.some(
            (item, idx) => item.matchLoading !== dataSource[idx]?.matchLoading
        );

        if (hasChange) {
            setDataSource(newData);
        }
    }, [skuMatchLoadingList]);



    const beforeUpload = async (file, fileList, record, type) => {
        if (type === BATCH_RECORD_TYPE.MATCHIMG || type === BATCH_RECORD_TYPE.SIM_RECOLOR_INPUT) {
            setSkuMatchLoadingList(prev => {
                if (prev.includes(record.skuId)) return prev;
                return [...prev, record.skuId];
            });
        }

        recordRef.current = record
        uploadDebounce(file, fileList, type, 1, record)
        return false
    }
    const handleDrop = async (e, type) => {
        e.stopPropagation()
        if ("getFilesAndDirectories" in e.dataTransfer) {
            const filesAndDirs = await e.dataTransfer.getFilesAndDirectories()
            const fileList = await Utils.getFilesFromDirs(filesAndDirs, "/")
            console.log('===handleDrop===')
            if ((type === BATCH_RECORD_TYPE.MATCHIMG || type === BATCH_RECORD_TYPE.SIM_RECOLOR_INPUT) && recordRef.current?.skuId) {
                setSkuMatchLoadingList(prev => {
                    if (prev.includes(recordRef.current.skuId)) return prev;
                    return [...prev, recordRef.current.skuId];
                })
            }
            uploadDebounce(fileList[0], fileList, type)
            return false
        }
    }

    // 打开素材抽屉  selectedValue: 已选择的素材值, uploadCount: 上传数量, record: 当前记录, uploadType: 素材类型
    const openReferenceDrawer = (selectedValue, uploadCount, record, uploadType) => {
        setDrawSelectedValue(uploadType === BATCH_IMAGES_TYPE.IMAGE_TO_VIDEO_BATCH ? (selectedValue || '') : [...selectedValue])
        setUploadCount(uploadCount)
        recordRef.current = record
        setUploadType(uploadType);
        setDrawOpen(true)
    }

    const getDroppedFiles = async (e) => {
        if ("getFilesAndDirectories" in e.dataTransfer) {
            const filesAndDirs = await e.dataTransfer.getFilesAndDirectories()
            return await Utils.getFilesFromDirs(filesAndDirs, "/")
        }
        return Array.from(e.dataTransfer.files || [])
    }

    const handleRefListDrop = async (e, record, uploadType = projectType) => {
        e.preventDefault()
        e.stopPropagation()
        const fileList = await getDroppedFiles(e)
        if (!fileList?.length) return
        setPendingRefDropFiles(fileList)
        const maxCount = uploadType === BATCH_IMAGES_TYPE.FUSIONWEAR_BATCH ? 5 : 10
        openReferenceDrawer([], maxCount, record, uploadType)
    }

    // 为recordRef.current更新为最新的项，避免旧的recordRef.current覆盖保存
    useEffect(() => {
        if (dataSource.length > 0) {
            const updatedRecord = dataSource.find(item => item.skuId === recordRef.current.skuId);
            if (updatedRecord) {
                recordRef.current = updatedRecord;
            }
        }
    }, [dataSource, recordRef.current])

    const handleImageToVideoPromptApply = useCallback((promptValue) => {
        const nextPrompt = (promptValue || '').trim()
        setDataSource(prev => {
            if (Object.keys(recordRef.current).length === 0 && selectedRows.length > 0) {
                const selectedIds = new Set(selectedRows.map(item => item.skuId))
                return prev.map(item => selectedIds.has(item.skuId) ? { ...item, prompt: nextPrompt } : item)
            }
            const targetId = recordRef.current.skuId
            return prev.map(item => item.skuId === targetId ? { ...item, prompt: nextPrompt } : item)
        })
        recordRef.current = {}
        footerBarRef.current?.handleBatchExit()
    }, [selectedRows, setDataSource])

    // 抽屉中确认选择模特、姿势、背景素材
    const handleReferenceChange = async (value) => {
        console.log('抽屉选择', value);
        let updatedData = [];

        // 获取当前操作类型对应的字段
        const fieldMap = {
            [BATCH_IMAGES_TYPE.CHANGE_MODEL_BATCH]: "modelList",
            [BATCH_IMAGES_TYPE.TRYON_BATCH]: "refList",
            [BATCH_IMAGES_TYPE.CHANGE_BKG_BATCH]: "bkgList",
            [BATCH_IMAGES_TYPE.FUSIONWEAR_BATCH]: "modelList",
            [BATCH_IMAGES_TYPE.SMART_DETAIL_PAGE_BATCH]: "refList",
            [BATCH_IMAGES_TYPE.IMAGE_TO_VIDEO_BATCH]: "prompt",
        };
        const fieldKey = fieldMap[uploadType];
        if (!fieldKey) return;

        let smartDetailPageNum = null
        let shouldFetchSmartDetailPageNum = false
        let smartDetailSelectedKey = ''
        let smartDetailSelectedId = ''
        let smartDetailSelectedCustom = 0
        let smartDetailSelectedUrl = ''
        if (uploadType === BATCH_IMAGES_TYPE.SMART_DETAIL_PAGE_BATCH) {
            const selectedItem = Array.isArray(value) ? value?.[0] : null
            const presetNum = Number(selectedItem?.attr?.detailPageNum ?? selectedItem?.detailPageNum) || 0
            if (presetNum > 0) {
                smartDetailPageNum = presetNum
            } else if (selectedItem?.key) {
                shouldFetchSmartDetailPageNum = true
                smartDetailSelectedKey = selectedItem.key
                smartDetailSelectedId = selectedItem?.id || selectedItem?.key || ''
                smartDetailSelectedCustom = selectedItem?.custom ? 1 : 0
                smartDetailSelectedUrl = selectedItem?.url || selectedItem?.imageUrlWithVersion || selectedItem?.imageUrl || ''
            }
        }

        const selectedIds = Object.keys(recordRef.current).length === 0 && selectedRows.length > 0
            ? selectedRows.map(item => item.skuId)
            : [recordRef.current.skuId].filter(Boolean)

        setDataSource(prev => {
            let newData = [...prev];

            if (Object.keys(recordRef.current).length === 0 && selectedRows.length > 0) {
                const selectedIdSet = new Set(selectedIds);

                newData = newData.map(item => {
                    if (selectedIdSet.has(item.skuId)) {
                        return {
                            ...item,
                            [fieldKey]: fieldKey === 'prompt' ? value : [...value],
                            ...(uploadType === BATCH_IMAGES_TYPE.SMART_DETAIL_PAGE_BATCH ? { detailPageNum: smartDetailPageNum || 0 } : {})
                        };
                    }
                    return item;
                });
            } else {
                const targetId = recordRef.current.skuId;
                newData = newData.map(item => {
                    if (item.skuId === targetId) {
                        return {
                            ...item,
                            [fieldKey]: fieldKey === 'prompt' ? value : [...value],
                            ...(uploadType === BATCH_IMAGES_TYPE.SMART_DETAIL_PAGE_BATCH ? { detailPageNum: smartDetailPageNum || 0 } : {})
                        };
                    }
                    return item;
                });
            }

            updatedData = newData;
            return newData;
        });

        recordRef.current = {};
        footerBarRef.current?.handleBatchExit();

        if (uploadType === BATCH_IMAGES_TYPE.SMART_DETAIL_PAGE_BATCH && shouldFetchSmartDetailPageNum && selectedIds.length > 0) {
            try {
                props.setSmartDetailReferLoading?.(true)
                const res = await API.doDetailPageNum({
                    key: smartDetailSelectedKey,
                    custom: smartDetailSelectedCustom,
                })
                if (res?.code !== 0) throw new Error(res?.message || '参考图分析失败')
                const nextDetailPageNum = props.getSmartDetailNum?.(res?.data) || props.getSmartDetailNum?.(res?.attr) || 0
                if (!nextDetailPageNum) throw new Error('参考图分析结果为空')
                if (smartDetailSelectedCustom && smartDetailSelectedKey) {
                    try {
                        if (!smartDetailSelectedUrl) throw new Error('参考图缺少url')
                        await API.saveCustomMaterialv2({
                            id: smartDetailSelectedId || smartDetailSelectedKey,
                            image: smartDetailSelectedUrl,
                            attr: { detailPageNum: nextDetailPageNum },
                        })
                    } catch (e) { }
                }
                const selectedIdSet = new Set(selectedIds)
                setDataSource(prev => prev.map(item => (
                    selectedIdSet.has(item.skuId)
                        ? {
                            ...item,
                            detailPageNum: nextDetailPageNum,
                            refList: Array.isArray(item?.refList) && item.refList.length > 0
                                ? [
                                    { ...item.refList[0], attr: { ...(item.refList[0]?.attr || {}), detailPageNum: nextDetailPageNum } },
                                    ...item.refList.slice(1),
                                ]
                                : item?.refList,
                        }
                        : item
                )))
            } catch (err) {
                message.warning(err?.message || '参考图分析失败')
            } finally {
                props.setSmartDetailReferLoading?.(false)
            }
        }
    };


    // 选择素材抽屉
    useEffect(() => {
        if (!drawOpen) return
        materialRef.current?.refresh?.()
    }, [drawOpen])

    useEffect(() => {
        if (!drawOpen || !pendingRefDropFiles?.length) return
        const files = pendingRefDropFiles
        setPendingRefDropFiles(null)
        setTimeout(() => {
            materialRef.current?.uploadAndConfirm?.(files)
        }, 0)
    }, [drawOpen, pendingRefDropFiles])

    // 批量禁止选中
    const [batchMode, setBatchMode] = useState()
    const getBatchMode = (mode) => {
        setBatchMode(mode)
    }

    const goBack = () => {
        if (isEdit) {
            navigate(-1)
        }
        setFileList([])
        if (dataSource.length === 0) {
            API.batchRemoveProject({
                projectIds: [projectId],
            }).then(res => {
                if (res?.code == 0) {
                    if (isProCenter) navigate('/home/myProject/batchImages')
                    else navigate('/home/product/batchImages')
                } else throw new Error(res.message)
            })
        } else {
            if (isProCenter) navigate('/home/myProject/batchImages')
            else navigate('/home/product/batchImages')
        }
    }

    // 辅品排序
    const [data, setData] = useState([]);
    const [currentSkuID, setCurrentSkuID] = useState('');
    const editCommoditySort = (record) => {
        if (record?.refList?.length === 0) return
        setCurrentSkuID(record.skuId)
        setData(JSON.parse(JSON.stringify(record?.refList ?? [])));
        setCommoditySortOpen(true)
    }

    const handleSortOk = () => {
        setDataSource(prev => {
            return prev.map(item => {
                if (item.skuId === currentSkuID) {
                    return { ...item, refList: [...data] };
                }
                return item;
            });
        });
        setCommoditySortOpen(false);
    }

    const Text = useMemo(() => {
        return projectType == BATCH_IMAGES_TYPE.TRYON_BATCH ? 'AI试衣' :
            projectType == BATCH_IMAGES_TYPE.CHANGE_MODEL_BATCH ? '换模特' :
                projectType == BATCH_IMAGES_TYPE.CHANGE_BKG_BATCH ? '换背景' :
                        projectType == BATCH_IMAGES_TYPE.SIM_RECOLOR_BATCH ? '同款换色' :
                            projectType == BATCH_IMAGES_TYPE.IMAGE_FINER_BATCH ? 'AI超清' :
                                    projectType == BATCH_IMAGES_TYPE.WATERMARK_REMOVE_BATCH ? '去抹除' :
                                        projectType == BATCH_IMAGES_TYPE.FUSIONWEAR_BATCH ? '搭配上身' :
                                            projectType == BATCH_IMAGES_TYPE.SMART_DETAIL_PAGE_BATCH ? '服装详情页' :
                                                projectType == BATCH_IMAGES_TYPE.GRASS_PLANT_BATCH ? '种草图' :
                                                projectType == BATCH_IMAGES_TYPE.IMAGE_TO_VIDEO_BATCH ? '图生视频' :
                                                    ''
    }, [projectType])

    const isRowSelectionDisabled = useCallback((record) => {
        if (batchMode == 'appendTop' || batchMode == 'appendBottom') {
            return record.inputImages?.filter(item => item.mainImage === true)?.[0]?.clothType !== (batchMode == 'appendTop' ? 1 : 0)
        }
        if (batchMode == 'appendCSimRecolorMatch') {
            return record.flatType === 'material'
        }
        return false
    }, [batchMode])

    const handleRowSelect = useCallback((record) => {
        if (!showSelectionColumn || isRowSelectionDisabled(record)) return
        setSelectedRowKeys(prev => {
            const exists = prev.includes(record.skuId)
            const next = exists ? prev.filter(id => id !== record.skuId) : [...prev, record.skuId]
            setSelectedRows(dataSource.filter(item => next.includes(item.skuId)))
            return next
        })
    }, [showSelectionColumn, isRowSelectionDisabled, dataSource])



    /* ================= 服装详情页相关弹窗 ================= */


    return (
        <>
            <div className={styles.tableWrap}>
                <div className={styles.GoBack}>
                    <GoBack onClick={() => goBack()} />
                    <span className={styles.TaskId}>项目ID：{projectSerial}</span>
                    <span className={styles.TaskTitle}>
                        {Text}-{projectName}
                        {!isEdit && <EditOutlined style={{ marginLeft: '8px' }} onClick={() => editProjectName()} />}
                    </span>
                </div>
                <Table
                    className='personalTable'
                    rowKey="skuId"
                    columns={skuColumns}
                    dataSource={dataSource}
                    tableLayout="auto"
                    pagination={false}
                    {...(showSelectionColumn && {
                        rowSelection: {
                            selectedRowKeys,
                            onChange: (selectedRowKeys, selectedRows) => {
                                setSelectedRowKeys(selectedRowKeys);
                                setSelectedRows(selectedRows);
                            },
                            getCheckboxProps: record => ({
                                disabled: isRowSelectionDisabled(record)
                            })
                        }
                    })}
                    onRow={(record) => showSelectionColumn ? {
                        onClickCapture: (e) => {
                            if (e.target?.closest?.('.ant-checkbox-wrapper') || e.target?.closest?.('.ant-checkbox')) return
                            e.preventDefault()
                            e.stopPropagation()
                            handleRowSelect(record)
                        }
                    } : {}}
                    scroll={{
                        x: 'max-content',
                        y: `calc(100vh - 404px)`,
                    }}
                />
            </div>
            <PSAIModal
                title="添加源素材"
                maxWidth={1100}
                open={uploadOpen}
                footer={null}
                onCancel={() => setUploadOpen(false)}
            >
                <UploadBox
                    projectType={projectType}
                    setUploadOpen={setUploadOpen}
                    onUpload={props.handleAddMore}
                    onMyProjectUpload={props.onMyProjectUpload}
                />
            </PSAIModal>
            <PSAIModal
                title="辅品数量编辑和排序"
                maxWidth={520}
                open={commoditySortOpen}
                onCancel={() => setCommoditySortOpen(false)}
                onOk={handleSortOk}
            >
                <DragAndSort data={data} setData={setData} />
            </PSAIModal>
            <Drawer
                closable={false}
                onClose={() => setDrawOpen(false)}
                open={drawOpen}
                width={uploadCount === 1 ? 1700 : 1900}
                destroyOnHidden={true}
            >
                <SelectTryonPose
                    ref={materialRef}
                    setDrawOpen={setDrawOpen}
                    drawOpen={drawOpen}
                    maxCount={uploadCount}
                    projectType={projectType === BATCH_IMAGES_TYPE.TRYON_BATCH || projectType === BATCH_IMAGES_TYPE.GRASS_PLANT_BATCH ? uploadType : projectType}
                    value={drawSelectedValue}
                    onChange={handleReferenceChange}
                    onApplyImageToVideoPrompt={handleImageToVideoPromptApply}
                    onClose={() => setDrawOpen(false)}
                />
            </Drawer>
            <PSAIModal
                title={editNameTitle}
                maxWidth={400}
                okText={'确定'}
                open={editNameVisible}
                maskClosable={false}
                okButtonProps={{ disabled: false, loading: false }}
                onCancel={() => setEditNameVisible(false)}
                onOk={() => updateNameOk()}
            >
                <div className={styles.editNameContent}>
                    <Input
                        value={nickName}
                        suffix={`${nickName.length}/40`}
                        onChange={(e) => setNickName(e.target.value)}
                        maxLength={40}
                        placeholder='请输入新名称' />
                </div>
            </PSAIModal>
        </>

    )
})

export default TableWrap
